import type { PointerEvent as ReactPointerEvent } from "react";

import { useTouchListPickSession } from "@/lib/useTouchListPickSession";

export function AmlManufacturerChoiceList(props: {
  manufacturers: readonly string[];
  disabled?: boolean;
  onChoose: (manufacturerName: string) => void;
}): JSX.Element {
  const touchListPick = useTouchListPickSession(true);
  return (
    <div className="flex flex-col gap-2">
      <p className="text-base text-slate-600">Which manufacturer is printed on the label?</p>
      {props.manufacturers.map((name) => (
        <button
          key={name}
          type="button"
          disabled={props.disabled}
          className="min-h-12 rounded-md border border-slate-300 bg-white px-3 text-left text-base font-medium text-slate-900 touch-manipulation focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 disabled:cursor-not-allowed disabled:opacity-60"
          onPointerDown={(event: ReactPointerEvent<HTMLButtonElement>) => {
            touchListPick.onListItemPointerDown(event, () => {
              if (props.disabled) return;
              props.onChoose(name);
            });
          }}
        >
          {name}
        </button>
      ))}
    </div>
  );
}
